import platform from 'platform'
import is from 'is_js'

export default {
  os: (): string => {
    if (is.android()) return 'ANDROID'
    if (is.linux()) return 'LINUX'
    if (is.windows()) return 'WINDOWS'
    if (is.ios()) return 'IOS'
    if (is.mac()) return 'MACOSX'
    else return ''
  },
  browser: (): string => {
    if (is.chrome()) return 'CHROME'
    if (is.firefox()) return 'FIREFOX'
    if (is.safari()) return 'SAFARI'
    if (is.edge()) return 'EDGE'
    else return ''
  },
  device: (): string => {
    return platform.product || ''
  },
}
